import React from 'react';
import { ButtonWithIcon } from '@els/els-react--button-next';
import { Icon } from '@els/els-react--icon';
import { Messages } from '../../translations/message.models';

export interface CreateQuizBreadcrumbProps {
  messages: Messages;
  onSelfStudyClick: () => void;
}

const CreateQuizBreadcrumb = ({ messages, onSelfStudyClick }: CreateQuizBreadcrumbProps) => (
  <div className="c-ssa-create-quiz-breadcrumb" data-testid="ssa-create-quiz-breadcrumb-container">
    <nav
      className="c-ssa-create-quiz-breadcrumb__trail"
      aria-label={messages.BREADCRUMB}
      data-testid="ssa-create-quiz-breadcrumb"
    >
      <ol className="c-ssa-create-quiz-breadcrumb__list">
        <li className="c-ssa-create-quiz-breadcrumb__item">
          <button
            type="button"
            className="c-ssa-create-quiz-breadcrumb__crumb u-els-debuttonize u-els-anchorize"
            data-testid="ssa-create-quiz-breadcrumb-placeholder"
          >
            {messages.HOME}
          </button>
          <Icon id="ssa-create-quiz-breadcrumb-separator-home" sprite="ChevronRight" isDecorative className="c-ssa-create-quiz-breadcrumb__separator" />
        </li>
        <li className="c-ssa-create-quiz-breadcrumb__item">
          <button
            type="button"
            className="c-ssa-create-quiz-breadcrumb__crumb u-els-debuttonize u-els-anchorize"
            onClick={onSelfStudyClick}
            data-testid="ssa-create-quiz-breadcrumb-self-study"
          >
            {messages.SELF_STUDY}
          </button>
          <Icon id="ssa-create-quiz-breadcrumb-separator-self-study" sprite="ChevronRight" isDecorative className="c-ssa-create-quiz-breadcrumb__separator" />
        </li>
        <li className="c-ssa-create-quiz-breadcrumb__item" aria-current="page" data-testid="ssa-create-quiz-breadcrumb-current">
          {messages.CREATE_A_QUIZ}
        </li>
      </ol>
    </nav>
    <ButtonWithIcon
      type="link"
      sprite="ArrowLeft"
      className="c-ssa-create-quiz-breadcrumb__back-link"
      onClick={onSelfStudyClick}
      data-testid="ssa-create-quiz-back-to-self-study"
    >
      {messages.BACK_TO_SELF_STUDY}
    </ButtonWithIcon>
  </div>
);

export default CreateQuizBreadcrumb;
